import * as React from 'react';

import hoistNonReactStatics from 'js/lib/hoistNonReactStatics';

import type { CustomLabelsV2 } from './__generated__/CustomLabelsV2';

type OuterProps = any & {
  degreeId: string;
};

type InnerProps = OuterProps & {
  customLabelsV2?: CustomLabelsV2;
};

type CustomLabelsData = {
  data: {
    byDegreeId: CustomLabelsV2;
  };
};

type MutationProps = OuterProps & {
  getCustomLabels: ({
    variables,
  }: {
    variables: { degreeId: string; body: Record<string, any> };
  }) => Promise<CustomLabelsData>;
};

export default <PropsFromCaller extends OuterProps>() => {
  return (Component: React.ComponentType<InnerProps>): React.ComponentType<MutationProps> => {
    const componentName = Component.displayName || Component.name;

    type State = {
      customLabelsV2?: CustomLabelsV2;
    };

    class CustomLabelsByDegreeIdDataProviderWrapper extends React.Component<MutationProps, State> {
      static displayName = `CustomLabelsByDegreeIdDataProviderWrapper(${componentName})`;

      state = {
        customLabelsV2: undefined,
      };

      componentDidMount() {
        const { getCustomLabels, degreeId } = this.props;

        getCustomLabels({
          variables: {
            degreeId,
            body: {},
          },
        }).then(({ data }: $TSFixMe) => {
          const customLabelsV2 = data?.byDegreeId?.[0] || null;

          this.setState({ customLabelsV2 });
        });
      }

      render() {
        const { customLabelsV2 } = this.state;

        return React.createElement(Component, Object.assign({}, this.props, { customLabelsV2 }));
      }
    }

    hoistNonReactStatics(CustomLabelsByDegreeIdDataProviderWrapper, Component);

    return CustomLabelsByDegreeIdDataProviderWrapper;
  };
};
